var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmentTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 105,
    viewBox: "0 0 141 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.0011 84.7495L15.0845 55.8328C11.8345 52.5828 6.58447 52.5828 3.33447 55.8328C0.0844726 59.0828 0.0844726 64.3328 3.33447 67.5828L38.1678 102.416C41.4178 105.666 46.6678 105.666 49.9178 102.416L138.085 14.2495C141.335 10.9995 141.335 5.74951 138.085 2.49951C134.835 -0.750488 129.584 -0.750488 126.334 2.49951L44.0011 84.7495Z",
    fill: "url(#paint0_linear_2681_6044)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2681_6044",
    x1: 70.7095,
    y1: 0.0620117,
    x2: 70.7095,
    y2: 104.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FCF97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C75E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentTick);
export default __webpack_public_path__ + "static/media/assessmentTick.1333c2427dc17ab2921296df0c0ca547.svg";
export { ForwardRef as ReactComponent };